import React, { ReactNode } from 'react'
import { Spinner } from '@web/walter-ui-kit'
import { VerificationLevel } from '@web/walter-lib/api'

import ConfirmMigration from './views/СonfirmWrapper'
import StartMigration from './views/StartWrapper'
import styles from './style.module.css'
import { useAccountUserInfo } from '~api'

interface Props {
    isSumSubOpen: boolean
    setSumSubOpen: (isOpen: boolean) => void
}

export function Content({ setSumSubOpen, isSumSubOpen }: Props) {
    const { data: userAccountInfoData, isValidating: isUserAccountInfoLoading } = useAccountUserInfo()

    let content: ReactNode

    if (isUserAccountInfoLoading) {
        return (
            <div className={styles.spinner}>
                <Spinner size={30} />
            </div>
        )
    }

    if (userAccountInfoData?.verification_level === VerificationLevel.STARTER_NONE) {
        content = <StartMigration isSumSubOpen={isSumSubOpen} setSumSubOpen={setSumSubOpen} />
    }

    if (userAccountInfoData?.verification_level !== VerificationLevel.STARTER_NONE) {
        content = <ConfirmMigration />
    }

    return <>{content}</>
}
